import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  hidden: {
    marginTop: '0.5rem',
    marginBottom: '1rem'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '0.5rem',

    '& > :last-child': {
      marginLeft: '0.5rem'
    }
  },

  button: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
